import { AuthGuard } from '../core/security/auth-guard.service';
import { Routes } from '@angular/router';
import { CpComponent } from './cp.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';

export const routes: Routes = [
  {
    path: '',
    component: CpComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./../home/home.module').then(m => m.HomeModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'forbidden/:module',
        component: ForbiddenComponent,
        data: {},
      },
      {
        path: 'account',
        loadChildren: () => import('./../account/account.module').then(m => m.AccountModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'reports',
        loadChildren: () => import('./../reports/reports.module').then(m => m.ReportsModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'phone-numbers',
        loadChildren: () => import('./../phone-numbers/phone-numbers.module').then(m => m.PhoneNumbersModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'firewall',
        loadChildren: () => import('./../firewall/firewall.module').then(m => m.FirewallModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'messaging',
        loadChildren: () => import('./../messaging/messaging.module').then(m => m.MessagingModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'advanced-messaging',
        loadChildren: () => import('../pro-messaging/pro-messaging.module').then(m => m.ProMessagingModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'fax',
        loadChildren: () => import('./../fax/fax.module').then(m => m.FaxModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'pbx',
        loadChildren: () => import('./../pbx/pbx.module').then(m => m.PbxModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'contacts',
        loadChildren: () => import('./../contact/contact.module').then(m => m.ContactModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'events-flow',
        loadChildren: () => import('./../events-flow/events-flow.module').then(m => m.EventsFlowModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'softphone',
        children: [
          {
            path: 'basic',
            loadChildren: () =>
              import('./../basic-softphone/basic-soft-phone.module').then(m => m.BasicSoftPhoneModule),
            canActivateChild: [AuthGuard],
          },
          {
            path: 'premium',
            loadChildren: () => import('./../softphone/soft-phone.module').then(m => m.SoftPhoneModule),
            canActivateChild: [AuthGuard],
          },
        ],
      },
      /*{
        path: 'softphone',
        loadChildren: () => import('./../softphone/soft-phone.module').then(m => m.SoftPhoneModule),
        canActivateChild: [AuthGuard],
      },*/
      {
        path: 'downloads',
        loadChildren: () => import('./../downloads/downloads.module').then(m => m.DownloadsModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'conference',
        loadChildren: () => import('./../video-conference/video-conference.module').then(m => m.VideoConferenceModule),
        canActivateChild: [AuthGuard],
      },
    ],
  },

  // {path: '', redirectTo: 'home', pathMatch: 'full'},
];
